module.exports = __webpack_public_path__ + "assets/img/succ1.5bfbc92b.png";